module.exports = __webpack_public_path__ + "img/partner2.108e1cd7.png";